import { ERoomsCount, TRoomsFilterOptionValue } from 'shared/types/offersHistory';
import { sendAnalytics } from 'shared/utils/analytics';

export const trackRoomsFilterChange = (value: TRoomsFilterOptionValue) => {
  sendAnalytics({
    action: 'Click',
    label: 'history_offers_rooms',
    page: {
      extra: {
        roomscount: value === 'all' || value === ERoomsCount.Studio ? null : value,
        flattype: getFlatType(value),
      },
    },
  });
};

function getFlatType(value: TRoomsFilterOptionValue) {
  switch (value) {
    case 'all':
      return null;
    case ERoomsCount.Studio:
      return 'studio';
    default:
      return 'rooms';
  }
}
